import * as React from "react";

import "./input.scss";

import {cs}           from "@Common/react/chain-services";
import {FieldOptions} from "@Common/ui-components/field-options/fieldOptions";


export const Input = ({inputField, inputFieldName=inputField.fieldKey, inputType="text",
dataFieldName=inputField.displayLabel, fieldValue, className='', changeHandler=()=>{}, readOnly=false, hidden=false, xdQaType="text_field", initRef=null, extraInfo={}}) => cs(
    ["phoneFormatOptions", ({}, next) => next({
        1: "###.###.####",
        2: "###-###-####",
        3: "### ### ####",
        4: "(###) ###.####",
        5: "(###) ###-####",
        6: "(###) ### ####",
        11: "+1 ###.###.####",
        12: "+1 ###-###-####",
        13: "+1 ### ### ####",
        14: "+1 (###) ###.####",
        15: "+1 (###) ###-####",
        16: "+1 (###) ### ####",
        17: "### ###-####",
        21: "+1 ### ###-####"
    })],
    ["allowFieldOptions", ({phoneFormatOptions}, next) => next(
        !!phoneFormatOptions.hasOwnProperty((parseInt(inputField.idTemplateFieldFormat))) && inputField.idDisplayStyle == 1
    )],
    ["phoneFormatExample", ({phoneFormatOptions}, next) => next(phoneFormatOptions[inputField.idTemplateFieldFormat])],

    ({allowFieldOptions, phoneFormatExample}) => (
        <div className="input-oi9">
            {allowFieldOptions ?
                <FieldOptions
                    reference={initRef}
                    fieldData={inputField}
                    explainerText={phoneFormatExample}
                >
                    <input
                        id={inputField.fieldKey}
                        name={inputFieldName}
                        type={inputType}
                        data-fieldname={dataFieldName}
                        className={"input-54x "+className + " field-options-included"}
                        value={fieldValue}
                        onChange={changeHandler}
                        readOnly={readOnly}
                        hidden={hidden}
                        onKeyPress={changeHandler}
                        maxLength={[1,2,3,17].includes(inputField.idTemplateFieldFormat) ? 12 : [4,5,6].includes(inputField.idTemplateFieldFormat) ? 14 : [11,12,13,21].includes(inputField.idTemplateFieldFormat) ? 15 : [14,15,16].includes(inputField.idTemplateFieldFormat) ? 17 : inputField.maxLength}
                        xd-qa-type={xdQaType}
                        xd-qa-name={inputField.fieldKey}
                        ref={ref => initRef.set(ref)}
                        {...extraInfo}
                    />
                </FieldOptions>
            :
                <input
                    name={inputFieldName}
                    type={inputType}
                    data-fieldname={dataFieldName}
                    className={"input-54x "+className}
                    value={fieldValue}
                    onChange={changeHandler}
                    readOnly={readOnly}
                    hidden={hidden}
                    onKeyPress={changeHandler}
                    maxLength={[1,2,3,17].includes(inputField.idTemplateFieldFormat) ? 12 : [4,5,6].includes(inputField.idTemplateFieldFormat) ? 14 : [11,12,13,21].includes(inputField.idTemplateFieldFormat) ? 15 : [14,15,16].includes(inputField.idTemplateFieldFormat) ? 17 : inputField.maxLength}
                    xd-qa-type={xdQaType}
                    xd-qa-name={inputField.fieldKey}
                    ref={initRef}
                    {...extraInfo}
                />
            }
        </div>
    )
);